exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-input__inner::-webkit-input-placeholder{color:#666}.el-input__inner::-moz-placeholder{color:#666}.el-input__inner::-ms-input-placeholder{color:#666}.regist-content{width:100vw;min-height:100vh}.regist-content .el-icon-success{bottom:0.2rem;right:0}.regist-content .info-content{max-width:6.66667rem;width:100%}.regist-content .distpicker-address-wrapper select{min-width:initial;-webkit-box-flex:1;-webkit-flex:1;flex:1}", ""]);

// exports
